export const LiveStreamWaitingForStart = 'WAITING_FOR_START';
export const LiveStreamInProgress = 'LIVE_STREAM_IN_PROGRESS';
export const LiveStreamEnded = 'LIVE_STREAM_ENDED';
